import { Button } from "@/components/ui/Button";
import { useLanguage } from "@/context/LanguageContext";
import { useWatchDogContext } from "@/context/WatchDogContext";
import type { WatchDogDateRange } from "@/lib/date";

export const getWatchDogDateRangeLabel = (
  range: WatchDogDateRange,
  language: "cs" | "en",
) => {
  const labels = {
    cs: {
      today: "Dnes",
      "7d": "7 dní",
      "14d": "14 dní",
      "21d": "21 dní",
      "28d": "28 dní",
      all: "Vše",
    },
    en: {
      today: "Today",
      "7d": "7 days",
      "14d": "14 days",
      "21d": "21 days",
      "28d": "28 days",
      all: "All",
    },
  } as const;

  return labels[language][range];
};

const ranges: WatchDogDateRange[] = ["today", "7d", "14d", "21d", "28d", "all"];

export function WatchDogDateRangeFilter() {
  const { language } = useLanguage();
  const { dateRange, setDateRange } = useWatchDogContext();
  const groupLabel =
    language === "cs"
      ? "Filtrovat výsledky podle období"
      : "Filter results by period";

  return (
    <div
      role="group"
      aria-label={groupLabel}
      className="flex flex-wrap items-center gap-2"
    >
      {ranges.map((range) => (
        <Button
          key={range}
          type="button"
          variant="secondary"
          size="sm"
          aria-pressed={dateRange === range}
          data-active={dateRange === range}
          onClick={() => setDateRange(range)}
        >
          {getWatchDogDateRangeLabel(range, language)}
        </Button>
      ))}
    </div>
  );
}
